import { setUser } from "../../redux/slices/user/_actions";

export const logOut = (history, dispatch) => {
  localStorage.removeItem("token");
  dispatch(setUser({}));
  history.push("/login");
};
